import styled from "styled-components";

export const RecourcesContainer = styled.div`
	display: grid;
    align-items: center;
    grid-template-columns: 1fr 1fr;
    column-gap: 6px;
    row-gap: 4px;
`;
